import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import ReactPaginate from "react-js-pagination";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Vakilkaro from "src/assets/brand/vakilkaro";
import { getTodayPayments } from "src/api/customerApis";
import { formatDate } from "src/services/helpers";
import Swal from "sweetalert2";
import authInstance from "src/api/apiConfig";
import { successAlert } from "src/utils/Swal";
import { COMPANY_NAME } from "src/services/const";

const Banking = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { emiStatusData } = useSelector((state) => state?.emiReducer);
  const SchemaName = sessionStorage.getItem("schemaName");
  const [minEndDate, setMinEndDate] = useState("");
  const [status, setStatus] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [emiStatus, setEmiStatus] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [printState, setPrintState] = useState(false);
  const [rows, setRows] = useState([]);
  const [org, setOrg] = useState([]);
  const [allSelectedData, setAllSelectedData] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const BRANCH_ID = sessionStorage.getItem("branc");
  const role = sessionStorage.getItem("role");
  const [commonData, setCommonData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState();

  const getAllcommonData = async () => {
    setLoading(true);
    try {
      const data = await authInstance.post("getallcommondata", {
        schemaName: SchemaName,
        page: page,
      });
      if (data.status === 200) {
        const { newCapital, newData, newJournal, newPayment, totals } =
          data?.data?.message;
        setTotal(totals);
        const combinedData = [
          ...newCapital,
          ...newData,
          ...newJournal,
          ...newPayment,
        ];
        // setCommonData(combinedData);
        setCommonData((prevData) => [...prevData, ...combinedData]);
        if (combinedData.length === 0) {
          setHasMore(false); // No more data to fetch
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllcommonData();
    if (printState) {
      generatePDF();
    }
  }, [printState, page]);

  const rowsPerPage = 10;

  const objData = {
    schemaName: SchemaName,
    emiStatus: "",
    startDate: "2022-01-01",
    enddate: "2024-06-24",
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handleSearch = () => {
    setStatus(true);
  };
  const fetchRecords = async (payload) => {
    try {
      const res = await getTodayPayments(payload);
      const filteredData =
        BRANCH_ID === "null"
          ? res?.data
          : res?.data.filter((item) => {
              return item.branchId.toString() === BRANCH_ID;
            });
      setRows(filteredData || []);
      setOrg(filteredData || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchRecords(objData);
  }, [status, showTable]);

  const handleStartDateChange = (e) => {
    const selectedStartDate = e.target.value;
    setStartDate(selectedStartDate);
    setMinEndDate(selectedStartDate);
    if (endDate < selectedStartDate) {
      setEndDate("");
    }
  };

  const download_btn = () => {
    setPrintState(true);
  };

  const handleSubmitEditForm = async () => {
    const payload = {
      status: emiStatus,
      schemaName: SchemaName,
    };
    const response = await authInstance.patch(
      `payment/${allSelectedData?.id}`,
      payload
    );
    if (response.status === 201) {
      fetchRecords(objData);

      successAlert("date successfully updated");
      setOpenModel(false);
    }
  };

  const verifyData = (company) => {
    Swal.fire({
      title: "Are you sure you want to verify this payment?",
      showCancelButton: true,
      confirmButtonText: "Verify",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          status: "paid",
          schemaName: SchemaName,
        };
        const response = await authInstance.patch(
          `payment/${company?.id}`,
          payload
        );
        if (response.status === 201) {
          fetchRecords(objData);
          successAlert(`status successfully updated`);
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const filterRows = () => {
    if (Array.isArray(org)) {
      const filteredData = org.filter((payment) => {
        const aadharNumber = payment?.customer?.aadharNumber
          ?.toString()
          .toLowerCase();
        const mobile = payment?.customer?.phoneNumber.toString().toLowerCase();
        const loanAccountNo =
          payment?.customer?.loanAccountNumber?.toLowerCase();
        const branchCode = payment.branch?.branchCode.toLowerCase();
        const branchName = payment.branch?.branchName.toLowerCase();
        const searchTerm = searchInput?.toLowerCase();

        if (!searchTerm) {
          return true;
        }

        if (!isNaN(searchTerm)) {
          return (
            aadharNumber.includes(searchTerm) || mobile.includes(searchTerm)
          );
        }
        if (searchTerm.trim().split(" ").length > 1) {
          return (
            loanAccountNo?.includes(searchTerm) ||
            branchName.includes(searchTerm) ||
            branchCode.includes(searchTerm)
          );
        }
        return (
          loanAccountNo?.includes(searchTerm) ||
          branchName.includes(searchTerm) ||
          branchCode.includes(searchTerm)
        );
      });
      setRows(filteredData);
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    filterRows();
    return () => {
      setRows([]);
    };
  }, [org, searchInput]);

  const getNormalizedDate = (item) => {
    return new Date(
      item?.paymentDate ||
        item?.DisbursementDate ||
        item?.entryDate ||
        "1970-01-01" // Default to earliest date if none are found
    );
  };

  const sortedData = commonData?.slice()?.sort((a, b) => {
    const dateA = getNormalizedDate(a);
    const dateB = getNormalizedDate(b);
    return dateB - dateA;
  });

  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <div className="content">
      <CModal
        scrollable
        visible={openModel}
        onClose={() => setOpenModel(false)}
        aria-labelledby="ScrollingLongContentExampleLabel2"
      >
        <CModalHeader>
          <CModalTitle id="ScrollingLongContentExampleLabel2">{`${allSelectedData?.customer?.firstName}`}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            <CCol xs={10}>
              <CFormInput
                type={"text"}
                value={emiStatus}
                placeholder={`${allSelectedData?.status}`}
                onChange={(e) => setEmiStatus(e.target.value)}
              />
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton onClick={handleSubmitEditForm} color="primary">
            Payment
          </CButton>
        </CModalFooter>
      </CModal>

      <CCard>
        <CCardHeader>
          <strong>All EMI Record</strong>
        </CCardHeader>
        <CCardBody>
          {showTable && (
            <div>
              <div className="searchinput">
                <CRow>
                  <CCol xs={12} md={4} lg={5}>
                    <CFormLabel htmlFor="groupName">
                      MobileNumber/AadharNumber
                    </CFormLabel>
                    <CFormInput
                      type="text"
                      size="sm"
                      placeholder="Enter desired value for searching"
                      aria-label="sm input example"
                      style={{ margin: "0px 0px 16px 0px" }}
                      onChange={handleSearchChange}
                      value={searchInput}
                    />
                  </CCol>

                  <CCol xs={12} md={4} lg={2}>
                    <Button
                      className="add-btn mr-10 w-auto"
                      onClick={download_btn}
                    >
                      Download
                    </Button>
                  </CCol>
                </CRow>
              </div>
              <div
                className="mb-2"
                ref={printState ? componentPDF : null}
                style={{ padding: printState ? "20px" : "0px" }}
              >
                {printState && (
                  <div className="print-div">
                    <div>
                      {/* <Vakilkaro /> */}
                      <h3>Riyms</h3>
                    </div>
                    <div>
                      <p>{COMPANY_NAME}</p>
                    </div>
                  </div>
                )}
                <CRow>
                  <CCol xs={6}>
                    <div>
                      <span>
                        Total Payment Amount :{" "}
                        {total?.totalPaymentAmount + total?.bankTotal}
                      </span>
                    </div>
                  </CCol>
                  <CCol xs={6}>
                    <div>
                      <span>
                        Total Disbursement Amount :{" "}
                        {total?.totalDisbursementAmount}
                      </span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol xs={6}>
                    <div>
                      <span>
                        Total Debit Amount :{" "}
                        {total?.totalDebitAmount - total?.bankTotal}
                      </span>
                    </div>
                  </CCol>
                  <CCol xs={6}>
                    <div>
                      <span>
                        Total Loan Amount :{" "}
                        {total?.totalLoanAmount + total?.totalCapitalAmount}
                      </span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol xs={6}>
                    <div>
                      <span>
                        Total Amount :{" "}
                        <span style={{ color: "green" }}>
                          {total?.totalPaymentAmount +
                            total?.totalCapitalAmount +
                            total?.bankTotal +
                            total?.bankTotal +
                            total?.totalLoanAmount -
                            total?.totalDisbursementAmount -
                            total?.totalDebitAmount}
                        </span>
                      </span>
                    </div>
                  </CCol>
                </CRow>

                <CTable hover className="" responsive>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell scope="col" className="">
                        <span>Sr. No.</span>
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="">
                        <span>Date</span>
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="">
                        <span>Name</span>
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="">
                        <span>Payment</span>
                      </CTableHeaderCell>
                      <CTableHeaderCell scope="col" className="">
                        <span>Recieved</span>
                      </CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {sortedData?.map((company, index) => {
                      return (
                        <CTableRow key={index}>
                          <CTableDataCell>
                            {indexOfFirstRow + index + 1}
                          </CTableDataCell>
                          <CTableDataCell>
                            {formatDate(
                              company?.paymentDate ||
                                company?.DisbursementDate ||
                                company?.entryDate ||
                                "--"
                            )}
                          </CTableDataCell>
                          <CTableDataCell>
                            {company?.customer?.firstName ||
                              company?.director?.directorName ||
                              company?.debitAccount ||
                              "--"}
                          </CTableDataCell>
                          <CTableDataCell>
                            {company?.debitAmount ||
                              company?.DisbursementAmount ||
                              "--"}
                          </CTableDataCell>

                          <CTableDataCell>
                            {company?.paymentAmount ||
                              company?.loanAmount ||
                              (company?.debitAccount === "Bank" &&
                                company?.debitAmount) ||
                              "--"}
                          </CTableDataCell>
                        </CTableRow>
                      );
                    })}
                  </CTableBody>
                  {loading && <div>Loading...</div>}
                </CTable>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div></div>
                <div className="pagination-container">
                  <CButton
                    onClick={handleNextPage}
                    disabled={loading || !hasMore}
                  >
                    Next
                  </CButton>
                </div>
              </div>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default Banking;
